/**
 * Processes a Firestore or Cloud Function error and extracts relevant information
 * @param {Error} error The error from Firestore or Cloud Functions
 * @returns {{ message: string, indexUrl?: string }} Processed error with message and optional index URL
 */
export function processFirestoreError(error) {
  // Handle Cloud Functions errors
  if (error?.details) {
    // Extract the clean error message without stack trace
    const message = error.details.split("\n")[0].trim();

    // Check if it's an index error
    const indexMatch = message.match(/https:\/\/console\.firebase\.google\.com\S+/);
    if (indexMatch) {
      return {
        message: "The query requires an index.",
        indexUrl: indexMatch[0],
      };
    }

    return { message };
  }

  // Handle regular Firestore errors
  const indexMatch = error.message.match(/https:\/\/console\.firebase\.google\.com\S+/);
  if (indexMatch) {
    return {
      message: "The query requires an index.",
      indexUrl: indexMatch[0],
      stack: error.stack,
    };
  }

  return { message: error.message };
}
